module.exports = __webpack_public_path__ + "img/chart-1.14e289a7.svg";